import clsx from "classnames";
import { Title } from "@/ui";
import classes from "../styles.module.scss";

/**
 * Coloured band above the FAQ card holding the section title.
 *
 * @param {boolean} [show] - Whether the band is rendered.
 * @param {string} [title] - Title shown in the band.
 * @param {string} [tag] - HTML tag for the title.
 * @param {string} [color] - Fill key for the band background.
 * @returns {JSX.Element|null}
 */
export default function FAQTitleBar({ show, title, tag, color }) {
  if (!show || !title) return null;

  return (
    <div className={clsx(classes.faq__titleBar, classes[`fill--${color}`])} data-sourceflow-prop="titleBarTitle">
      <Title title={title} tag={tag} className={classes.faq__titleBarTitle} />
    </div>
  );
}
